// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TwoColumnWrapper_wrapper__15N9q"};